import {
  BotAvatar,
  BotTitleH1,
} from 'common/components/BotLists/StyledContainer/StyledContainer';
import Box from 'common/components/Box';
import Button from 'common/components/Button';
import Image from 'common/components/Image';
import { saasModernTheme } from 'common/theme/saasModern';
import Link from 'next/link';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { display } from 'styled-system';

const HeadContainer = ({ data, buttonFillTryItStyle, cta_text }) => {
  const imageUrl =
    data.user?.profilePicture ||
    'https://previews.123rf.com/images/redlinevector/redlinevector2001/redlinevector200101077/137477582-ic%C3%B4ne-de-fine-ligne-de-profil-de-robot-bot-chat-bot-signe-de-contour-isol%C3%A9-d-aide-en-ligne.jpg';
 
  return (
    <Box sx={{ display: 'flex', gap: '8px', marginTop: '40px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: '5%',alignItems: 'center' }}>
        <BotAvatar>
            <Image
              src={imageUrl}
              className="profile-image"
              alt={data.user?.name}
            />
          </BotAvatar>
          <Link href={`https://www.app.swiftask.ai/?bot=${data?.id}`}>
            <Button title={cta_text || 'Try It'} {...buttonFillTryItStyle} />
          </Link>
      </div>
       
      <Box style={{ paddingLeft: '8px', width: '80%', marginTop: '8px' }}>
        <BotTitleH1>{data?.subTitle}</BotTitleH1>
        <h4 style={{ fontWeight: 'normal', marginTop: '16px' }}>
          {data.description}
        </h4>
      </Box>
    </Box>
  );
};

HeadContainer.propTypes = {
  buttonFillTryItStyle: PropTypes.object,
};

HeadContainer.defaultProps = {
  buttonFillTryItStyle: {
    type: 'button',
    fontSize: '14px',
    borderRadius: '4px',
    color: '#fff',
    colors: 'primaryWithBg',
    width: '150px',
    maxWidth: '100%',
  },
};
export default HeadContainer;
